import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Breakpoint } from '../../../interfaces/types/Breakpoint.type';

export interface ContainerProps {
  children: ReactNode;
  startingBreakpoint?: Breakpoint;
  enable?: boolean;
  className?: string;
  id?: string;
}

const Container: React.FC<ContainerProps> = ({
  children,
  startingBreakpoint = undefined,
  enable = true,
  className,
  id,
}) => {
  return (
    <div
      id={id || ''}
      className={classNames(
        {
          'container mx-auto': !startingBreakpoint && enable,
          'xs:container xs:mx-auto': startingBreakpoint === 'xs',
          'sm:container sm:mx-auto': startingBreakpoint === 'sm',
          'md:container md:mx-auto': startingBreakpoint === 'md',
          'lg:container lg:mx-auto': startingBreakpoint === 'lg',
          'xl:container xl:mx-auto': startingBreakpoint === 'xl',
          '2xl:container 2xl:mx-auto': startingBreakpoint === '2xl',
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;
